export const configKey = process.env.REACT_APP_CONFIG_KEY;
export const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

export const dealerDataCookieName = 'dealerdata';

export const chooseVwBrand = brand => {
  switch (brand) {
    case 'vwfs':
      return 'bluelabel';
    case 'vw6':
    case 'vw':
    case 'vwcv':
    case 'vwn':
      return 'vw6';
    default:
      return brand;
  }
};

export const getStyles = brandName => {
  return import(`@vwfs-bronson/bronson-${
    brandName.includes('vw') ? chooseVwBrand(brandName) : brandName
  }/dist/css/style.min.css`);
};

export const isPriceMockingEnabled = ['dev', 'int', 'cons'].includes(process.env.REACT_APP_ENV.toLowerCase());
